import { render, staticRenderFns } from "./BaseDrinksOnDay.vue?vue&type=template&id=1ca63073&scoped=true&"
import script from "./BaseDrinksOnDay.vue?vue&type=script&lang=ts&"
export * from "./BaseDrinksOnDay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca63073",
  null
  
)

export default component.exports